/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAudienceRouteImport } from './routes/_app/audience'
import { Route as AppMeRouteImport } from './routes/_app/me'
import { Route as AppRevenueRouteImport } from './routes/_app/revenue'
import { Route as AppSettlementsIndexRouteImport } from './routes/_app/settlements/index'
import { Route as AppSettlementsPayoutProfileRouteImport } from './routes/_app/settlements/payout-profile'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAudienceRoute = AppAudienceRouteImport.update({
  id: '/audience',
  path: '/audience',
  getParentRoute: () => AppRoute,
} as any)
const AppMeRoute = AppMeRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => AppRoute,
} as any)
const AppRevenueRoute = AppRevenueRouteImport.update({
  id: '/revenue',
  path: '/revenue',
  getParentRoute: () => AppRoute,
} as any)
const AppSettlementsIndexRoute = AppSettlementsIndexRouteImport.update({
  id: '/settlements/',
  path: '/settlements/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettlementsPayoutProfileRoute =
  AppSettlementsPayoutProfileRouteImport.update({
    id: '/settlements/payout-profile',
    path: '/settlements/payout-profile',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/audience': typeof AppAudienceRoute
  '/me': typeof AppMeRoute
  '/revenue': typeof AppRevenueRoute
  '/settlements/payout-profile': typeof AppSettlementsPayoutProfileRoute
  '/settlements/': typeof AppSettlementsIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/audience': typeof AppAudienceRoute
  '/me': typeof AppMeRoute
  '/revenue': typeof AppRevenueRoute
  '/': typeof AppIndexRoute
  '/settlements/payout-profile': typeof AppSettlementsPayoutProfileRoute
  '/settlements': typeof AppSettlementsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/audience': typeof AppAudienceRoute
  '/_app/me': typeof AppMeRoute
  '/_app/revenue': typeof AppRevenueRoute
  '/_app/': typeof AppIndexRoute
  '/_app/settlements/payout-profile': typeof AppSettlementsPayoutProfileRoute
  '/_app/settlements/': typeof AppSettlementsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/audience'
    | '/me'
    | '/revenue'
    | '/settlements/payout-profile'
    | '/settlements/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/audience'
    | '/me'
    | '/revenue'
    | '/'
    | '/settlements/payout-profile'
    | '/settlements'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/_app/audience'
    | '/_app/me'
    | '/_app/revenue'
    | '/_app/'
    | '/_app/settlements/payout-profile'
    | '/_app/settlements/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/audience': {
      id: '/_app/audience'
      path: '/audience'
      fullPath: '/audience'
      preLoaderRoute: typeof AppAudienceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/me': {
      id: '/_app/me'
      path: '/me'
      fullPath: '/me'
      preLoaderRoute: typeof AppMeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/revenue': {
      id: '/_app/revenue'
      path: '/revenue'
      fullPath: '/revenue'
      preLoaderRoute: typeof AppRevenueRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settlements/': {
      id: '/_app/settlements/'
      path: '/settlements'
      fullPath: '/settlements/'
      preLoaderRoute: typeof AppSettlementsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settlements/payout-profile': {
      id: '/_app/settlements/payout-profile'
      path: '/settlements/payout-profile'
      fullPath: '/settlements/payout-profile'
      preLoaderRoute: typeof AppSettlementsPayoutProfileRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAudienceRoute: typeof AppAudienceRoute
  AppMeRoute: typeof AppMeRoute
  AppRevenueRoute: typeof AppRevenueRoute
  AppIndexRoute: typeof AppIndexRoute
  AppSettlementsPayoutProfileRoute: typeof AppSettlementsPayoutProfileRoute
  AppSettlementsIndexRoute: typeof AppSettlementsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAudienceRoute: AppAudienceRoute,
  AppMeRoute: AppMeRoute,
  AppRevenueRoute: AppRevenueRoute,
  AppIndexRoute: AppIndexRoute,
  AppSettlementsPayoutProfileRoute: AppSettlementsPayoutProfileRoute,
  AppSettlementsIndexRoute: AppSettlementsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
